import { Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { institutionalVerificationService } from "../services/institutional-verification.service";

const { Dragger } = Upload;

const CertificateUploader = ({ institutionId, messageApi, disabled }) => {
  const uploadProps = {
    disabled,
    name: "file",
    multiple: false,
    accept: ".pdf",
    maxCount: 1,

    beforeUpload: (file) => {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        messageApi.error("File harus bertipe PDF!");
        return Upload.LIST_IGNORE;
      }

      const isLt1Mb = file.size / 1024 / 1024 < 1;
      if (!isLt1Mb) {
        messageApi.error("Ukuran file maksimal 1MB!");
        return Upload.LIST_IGNORE;
      }

      return true;
    },

    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        await institutionalVerificationService.uploadCertificate(
          institutionId,
          file
        );

        messageApi.success("Sertifikat berhasil diupload");

        setTimeout(() => {
          window.location.reload();
        }, 800);

        onSuccess();
      } catch (error) {
        messageApi.error("Upload sertifikat gagal");
        onError(error);
      }
    },
  };

  return (
    <Dragger {...uploadProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">
        Klik atau geser file ke sini untuk upload sertifikat
      </p>
      <p className="ant-upload-hint">Max file size 1Mb, tipe file .pdf</p>
    </Dragger>
  );
};

export default CertificateUploader;
